import { render, staticRenderFns } from "./crud-form.component.vue?vue&type=template&id=0dbeeaa7&scoped=true"
import script from "./crud-form.component.vue?vue&type=script&lang=ts"
export * from "./crud-form.component.vue?vue&type=script&lang=ts"
import style0 from "./crud-form.component.vue?vue&type=style&index=0&id=0dbeeaa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbeeaa7",
  null
  
)

export default component.exports